/* eslint-disable  */
//@ts-nocheck

import React, { useEffect, useState } from 'react';
import { browserHistory } from 'react-router';

import auth from './auth';
import ajax from './ajax';
import * as enums from '@playbook-technologies/common-enums';
import Header from './Header';
import InfluencerSelect from './InfluencerSelect';
import StatusBar from './StatusBar';
import { navigate, PATHS } from '@client/routes';
import { Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';

const PortalUserEdit = (props) => {
  const [portalUser, setPortalUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
  });
  const [postData, setPostData] = useState({
    role: 2,
  });

  const setInput = (e) => {
    const { name, value } = e.target;
    setPortalUser((prev) => {
      const next = { ...prev, [name]: value };
      if (auth.isModerator() && (next.firstName || next.lastName)) {
        next.username = `${next.firstName}${next.lastName}`
          .replace(/\s/g, '')
          .toLowerCase();
      }
      return next;
    });
  };

  const getPortalUserData = () => {
    //console.log('[PortalUserEdit] Fetching PortalUser data...');
    if (props.params.id === 0 || props.params.id === '0') {
      let dummy = {
        id: null,
        isActive: true,
        role: enums.PortalUser.Role.Moderator.value,
      };
      setPortalUser(dummy);
      setPostData(dummy);
      return;
    }
    ajax
      .getPortalUsers(props.params.id)
      .then((pu) => {
        setPortalUser(pu);
        setPostData(pu);
      })
      .catch((e) => {
        if (e === 'auth') {
          auth.logout();
          return;
        }
        setPortalUser({ id: null });
        setPostData({ id: null });
        StatusBar.sendErrorMessage(
          'You may be experiencing connectivity issues.',
        );
      });
  };

  useEffect(() => {
    getPortalUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = (postData) => {
    //console.log('[PortalUserEdit] Saving PortalUser...');
    ajax
      .upsertPortalUser(postData)
      .then((pu) => {
        //console.log('[PortalUserEdit] Saved PortalUser.', pu.id);
        navigate(PATHS.PORTAL_USERS);
      })
      .catch((e) => {
        console.log('[PortalUserEdit] Error saving PortalUser.', e);
        if (e === 'auth') {
          auth.logout();
        }
        StatusBar.sendErrorMessage(
          e?.response?.data ??
            e?.message ??
            'An error occured. Please check your data and try again.',
        );
      });
  };

  const goBack = (e) => {
    e.preventDefault();
    browserHistory.goBack();
  };

  const validate = (data) => {
    let validationResult = {
      passed: false,
      messages: [],
    };
    if (data.role === enums.PortalUser.Role.Influencer.value) {
      if (!data.influencerId || parseInt(data.influencerId) < 1) {
        validationResult.messages.push(
          'Users with Partner roles require a selected Partner.',
        );
      }
    }
    if (!data.email || data.email.length < 1) {
      validationResult.messages.push('E-mail address is required.');
    }
    if (validationResult.messages.length === 0) {
      validationResult.passed = true;
    }
    return validationResult;
  };

  const submit = (e) => {
    e.preventDefault();
    const newPostData = { ...postData, ...portalUser };

    let validationResults = validate(newPostData);
    if (validationResults.passed) {
      setPostData(newPostData);
      newPostData.role = parseInt(newPostData.role);
      newPostData.influencerId = parseInt(newPostData.influencerId);
      save(newPostData);
    } else {
      StatusBar.sendErrorMessage(validationResults.messages.join(' '));
      setPostData(newPostData);
    }
  };

  const merge = (newPostData) => {
    setPostData((prev) => ({ ...prev, ...newPostData }));
  };

  const roleChanged = (data) => {
    let wat = {
      role: data.role,
      influencerId: data.influencerId,
    };
    merge(wat);
  };

  let title = 'New User';
  if (portalUser && portalUser.firstName) {
    title = `${portalUser.firstName} ${portalUser.lastName}`;
  }

  if (!portalUser) {
    return <span></span>;
  }

  return (
    <div className="portalUserEdit">
      <Header>
        <Typography variant="h1">{title}</Typography>
        <div className="box">
          <div className="button-box flex gap-5">
            <PrimaryButton onClick={submit}>Save</PrimaryButton>
            <SecondaryButton onClick={goBack}>Cancel</SecondaryButton>
          </div>
        </div>
      </Header>
      <main id="main">
        <div>
          <br />
          <div className="general-settings">
            <div className="data-form-holder">
              <div className="data-row row-6">
                <div
                  className="input-holder"
                  style={{ width: auth.isModerator() ? '100%' : '50%' }}
                >
                  <label>First Name</label>
                  <input
                    type="text"
                    onChange={setInput}
                    name="firstName"
                    value={portalUser.firstName}
                    placeholder="First name"
                  />
                </div>
                <div
                  className="input-holder"
                  style={{ width: auth.isModerator() ? '100%' : '50%' }}
                >
                  <label>Last Name</label>
                  <input
                    type="text"
                    onChange={setInput}
                    name="lastName"
                    value={portalUser.lastName}
                    placeholder="Last name"
                  />
                </div>
              </div>
              <RoleEdit
                role={postData.role}
                influencerId={postData.influencerId}
                onChange={roleChanged}
              />
              <div className="data-block">
                <div className="input-holder">
                  <label>E-mail:*</label>
                  <input
                    type="text"
                    onChange={setInput}
                    name="email"
                    value={portalUser.email}
                    placeholder="Email"
                  />
                </div>
              </div>
            </div>
            <p style={{ color: '#f00' }}></p>
          </div>
        </div>
      </main>
      <StatusBar.Component />
    </div>
  );
};

export default PortalUserEdit;

// <RoleEdit role={role} influencerId={influencerId} onChange={onRoleChanged} />
const RoleEdit = (props) => {
  const roleChanged = (ev) => {
    let role = parseInt(ev.target.value);
    let influencerId = props.influencerId;
    if (role !== enums.PortalUser.Role.Influencer.value) {
      influencerId = null;
    }
    props.onChange({ role, influencerId });
  };

  const influencerChanged = (option) => {
    props.onChange({
      role: props.role,
      influencerId: option?.value ?? null,
    });
  };

  let influencerDropdown = <div className="input-holder"></div>;
  if (props.role == enums.PortalUser.Role.Influencer.value) {
    influencerDropdown = (
      <div className="input-holder">
        <label>Related Partner</label>
        <div className="absolute w-96">
          <InfluencerSelect
            influencerId={props.influencerId}
            onChange={influencerChanged}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="data-row row-6">
      <div className="input-holder">
        <label>Role</label>
        <select value={props.role} onChange={roleChanged}>
          {auth.isAdministrator() ? (
            <option key="1" value={enums.PortalUser.Role.Administrator.value}>
              Super Admin
            </option>
          ) : (
            ''
          )}
          <option key="2" value={enums.PortalUser.Role.Moderator.value}>
            Admin
          </option>
          <option key="3" value={enums.PortalUser.Role.Influencer.value}>
            Creator
          </option>
          <option key="4" value={enums.PortalUser.Role.ContentEditor.value}>
            Content Editor
          </option>
        </select>
      </div>
      {influencerDropdown}
    </div>
  );
};
